import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface SubmitCustomerRequestBody {
  requestType: 0 | 1;
  selectedKeys: string[];
  comments?: string | null;
  /** Honored by the backend only for privileged callers (Admin / HSE advisor). */
  overrideRecipientEmail?: string | null;
}

export interface SubmitCustomerRequestResult {
  requestId: number;
  sentTo: string;
  advisorNotified: boolean;
}

/**
 * Submits the Flexi quote-request forms (Additional Modules / Services).
 * The backend logs the request and emails sales (+ the OHS advisor).
 */
@Injectable({ providedIn: 'root' })
export class FlexiCustomerRequestService {
  private readonly base = `${environment.BASE_URL}/flexi/customer-request`;

  constructor(private http: HttpClient) {}

  submit(businessId: number, body: SubmitCustomerRequestBody): Observable<SubmitCustomerRequestResult> {
    return this.http.post<any>(`${this.base}/${businessId}`, body).pipe(
      map(r => ({
        requestId: r?.requestId ?? r?.RequestId ?? 0,
        sentTo: r?.sentTo ?? r?.SentTo ?? '',
        advisorNotified: r?.advisorNotified ?? r?.AdvisorNotified ?? false,
      })),
    );
  }
}
